/**
 * Composes the display title shown in the inbox row and the preview header:
 * "Ramp: Couldn't action email" when the customer resolved, otherwise just the
 * notification title.
 */
export const getGenericNotificationTitle = (
  title: string,
  customerName?: string
): string => (customerName ? `${customerName}: ${title}` : title)
